import { useAuth } from "~@/hoc/withAuthenticationRequired";
import usePlayerByUserIdQuery from "./usePlayerByUserIdQuery";

const useCurrentPlayerQuery = () => {
  const { user } = useAuth();

  const { data, isLoading, isPending, isError, error } = usePlayerByUserIdQuery({
    input: {
      keycloakUserId: user?.id!,
    },
    enabled: typeof user?.id === "string",
  });

  return {
    data,
    isLoading,
    isPending,
    isError,
    error,
  };
};

export default useCurrentPlayerQuery;
